import { createContext, useContext } from 'react';
import type { LoctopusClient } from '@loctopus/ticketing-sdk';
import type { CheckoutRuntimeConfig } from '../theme/types';

export interface AppContextValue {
  config: CheckoutRuntimeConfig;
  client: LoctopusClient;
}

export const AppContext = createContext<AppContextValue | null>(null);

export function useAppContext(): AppContextValue {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useAppContext must be used inside the App bootstrap provider.');
  return ctx;
}
